var map = {
	"./1.jpg": "9454",
	"./2.jpg": "5b53",
	"./3.jpg": "6b21",
	"./4.jpg": "cd89",
	"./5.jpg": "25ff",
	"./6.jpg": "39fe",
	"./Enoturismo_2.jpg": "06a5",
	"./Enoturismo_banner.jpg": "c6eb",
	"./Enoturismo_banners-mobile.jpg": "7dd2",
	"./Enoturismo_footer.jpg": "662a",
	"./Img_Visite-nos.jpg": "d796"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9da0";